import type { RoleMeta } from "@/types/auth";

/**
 * Demo personas — one per surface. The landing/login screens use these so a
 * demo viewer can jump straight into any of the three portals.
 */
export const ROLE_META: RoleMeta[] = [
  {
    role: "wholesaler",
    label: "Wholesaler",
    tagline: "Publish live stock, get instant order alerts, track sales.",
    demoUser: {
      id: "wh-hassan",
      name: "Hassan",
      phone: "254712000001",
      role: "wholesaler",
      businessName: "Kamukunji Kicks",
      plan: "Pro",
      language: "en",
    },
  },
  {
    role: "reseller",
    label: "Reseller",
    tagline: "See live stock across wholesalers, sell without phone calls.",
    demoUser: {
      id: "rs-amara",
      name: "Amara",
      phone: "254712000003",
      role: "reseller",
      businessName: "Amara Sneaker Studio",
      plan: "Growth",
      language: "en",
    },
  },
  {
    role: "admin",
    label: "Platform Admin",
    tagline: "Monitor the network, manage members, sell market intelligence.",
    demoUser: {
      id: "ad-team",
      name: "Njeri",
      phone: "254712000005",
      role: "admin",
      businessName: "StockSync Ops",
      plan: "Platform",
      language: "en",
    },
  },
];

export function roleMeta(role: string): RoleMeta | undefined {
  return ROLE_META.find((r) => r.role === role);
}

/** Landing route for each role after login. */
export const ROLE_HOME: Record<string, string> = {
  wholesaler: "/wholesaler",
  reseller: "/reseller",
  admin: "/admin",
};
